import { Button } from "@material-ui/core";
import * as React from "react";
import { AuthContext, IAuthContextData } from "src/auth";
import { ForgotPassword } from "../forgot-password/ForgotPassword";
import { BackgroundLogin } from "../shared/layout/background-login/BackgroundLogin";

// tslint:disable-next-line:no-empty-interface
export interface ILoginProps {}

// tslint:disable-next-line:no-empty-interface
export interface ILoginState {
  forgotPassword: boolean;
  viewPassword: boolean;
  user: {
    password: string;
    username: string;
  };
}

export class Login extends React.Component<ILoginProps, ILoginState> {
  constructor(props: ILoginProps) {
    super(props);

    this.state = {
      forgotPassword: false,
      user: {
        password: "",
        username: "",
      },
      viewPassword: false,
    };
  }

  public login(auth: IAuthContextData) {
    auth.Login(this.state.user);
  }

  public handleChangeUser =
    (param: any) => (event: React.FormEvent<HTMLInputElement>) => {
      const user = Object.assign({}, this.state.user);
      user[param] = event.currentTarget.value;
      this.setState({ user });
    };

  public render() {
    return this.state.forgotPassword
      ? this.getForgotPasswordPage()
      : this.getLoginPage();
  }

  private handleViewPassword = () => {
    this.setState({ viewPassword: !this.state.viewPassword });
  };

  private handleForgotPassword = () => {
    this.setState({ forgotPassword: !this.state.forgotPassword });
  };

  private getLoginPage = () => {
    return (
      <BackgroundLogin>
        <div className="background-login-box">
          <div className="background-login-field">
            <label>E-Mail</label>
            <input
              autoComplete="off"
              type="text"
              onChange={this.handleChangeUser("username")}
            />
          </div>
          <div className="background-login-field">
            <label>Senha</label>
            <input
              autoComplete="off"
              type={this.state.viewPassword ? "text" : "password"}
              onChange={this.handleChangeUser("password")}
            />
            <span
              className={
                this.state.viewPassword
                  ? "icon-visibility visible"
                  : "icon-visibility"
              }
              onClick={this.handleViewPassword}
            />
          </div>
          <div className="background-login-checkbox">
            <label>
              <input type="checkbox" />
              Mantenha-me conectado
            </label>
          </div>
          <AuthContext.Consumer>
            {(value: IAuthContextData) => (
              <Button type="button" onClick={() => this.login(value)}>
                Entrar
              </Button>
            )}
          </AuthContext.Consumer>
        </div>
        <a onClick={this.handleForgotPassword}>Esqueci a senha</a>
      </BackgroundLogin>
    );
  };

  private getForgotPasswordPage = () => {
    return <ForgotPassword onBack={this.handleForgotPassword} />;
  };
}



// WEBPACK FOOTER //
// ./src/component/login/Login.tsx